import React, { useEffect, useState } from "react";
import { getAssetKindValueLabel } from "./assetTypeOptions";

export function formatAssetKind(assetKind) {
  return assetKind?.split("/").pop()?.split(".")[0].replace("-", " ") || assetKind;
}

export default function AssetKind({ assetKind }) {
  const [label, setLabel] = useState(formatAssetKind(assetKind));

  useEffect(() => {
    let mounted = true;
    setLabel(formatAssetKind(assetKind));
    if (!assetKind || assetKind.includes("/")) {
      return () => {
        mounted = false;
      };
    }
    getAssetKindValueLabel(assetKind).then((option) => {
      if (mounted) {
        setLabel(option?.label || formatAssetKind(assetKind));
      }
    });
    return () => {
      mounted = false;
    };
  }, [assetKind]);

  return label;
}
